import { render } from "./BlogPage.vue?vue&type=template&id=2309c440&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=2309c440&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2309c440"]])

export default __exports__